// src/components/RepresentanteInfo/RepresentanteInfo.jsx
import React from "react";
import "./RepresentanteInfo.css";

export default function RepresentanteInfo({ descricao, titulo }) {

  // 🔹 Título da seção (representante)
  const tituloRepresentante = titulo
    ?.filter((item) => item.localizacao === "representante")
    .sort((a, b) => a.ordem - b.ordem);

  // 🔹 Textos da descrição
  const textosFiltrados = descricao
    ?.filter((item) => item.localizacao === "representantetexto")
    .sort((a, b) => a.ordem - b.ordem);

  return (
    <div className="content-text">

      {/* TÍTULO DINÂMICO */}
      {tituloRepresentante && tituloRepresentante.length > 0 ? (
        <h2>{tituloRepresentante[0].descricao}</h2>
      ) : (
        <h2>O Grupo Eliandro</h2> // fallback
      )}

      {/* DESCRIÇÃO */}
      {textosFiltrados && textosFiltrados.length > 0 ? (
        textosFiltrados.map((item) => (
          <React.Fragment key={item.id}>
            <p dangerouslySetInnerHTML={{ __html: item.descricao }} />
            <div style={{ marginBottom: "1rem" }} />
          </React.Fragment>
        ))
      ) : (
        <p>Descrição não disponível no momento.</p>
      )}

      <a
        href="/portalcandidato"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-representante"
      >
        Seja um Representante
      </a>
    </div>
  );
}
